import { TSelectObject } from 'types/dropdown';

export const assessmentLists: TSelectObject[] = [
  { label: '알지네이트 인상채득', value: 1 },
  { label: '구취 측정 결과', value: 2 },
  { label: '불소도포 시행', value: 3 },
  { label: 'TBI 교육', value: 4 },
  { label: '와타나베 칫솔질', value: 5 },
  { label: '기타', value: 6 },
];

export const assessmentLimits: { [key: string]: number } = {
  '알지네이트 인상채득': 2,
  '구취 측정 결과': 2,
  '불소도포 시행': 1,
  'TBI 교육': 2,
  '와타나베 칫솔질': 1,
  기타: 1,
};

export enum DHImplementationChartFields {
  date = 'date',
  location = 'location',
  assessment = 'assessment',
  memo = 'memo',
}

export const DHImplementationChartFormDefaultValues = {
  [DHImplementationChartFields.date]: new Date(),
  [DHImplementationChartFields.location]: '',
  [DHImplementationChartFields.assessment]: '',
  [DHImplementationChartFields.memo]: '',
};

export const AttachmentFilesDefaultValues = {
  0: null,
};
